import { render } from "./CustomSelectOneLaboratoryTestResult.vue?vue&type=template&id=706f8f34"
import script from "./CustomSelectOneLaboratoryTestResult.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneLaboratoryTestResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__